import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativePlanningWorkstreamsRoute extends Route {
  async setupController(controller, model) {
    super.setupController(controller, model);
    model.tfos.then(() => {});
    model.workstreams.then((results) => controller.set('workstreams', results));
    model.weeks.then(() => {});
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativePlanningWorkstreamsRoute,
);
